import React, { useState, useReducer, useMemo } from "react";
import Chevron from "../../../../assets/customSVG/ChevronCrm";
import CrmTagIcon from "../../../../assets/customSVG/crmTagIcon";
import Close from "../../../../assets/customSVG/Close";
import AddIcon from "../../../../assets/customSVG/AddIcon";
// import AddTags from '../../../../components/commonComponents/tags/AddTags';
import AddTags from '../../../../components/commonComponents/tags/AddTags';
import Tags from "../main/contact/Tags";
import { useAspSelector } from "test/jest-redux-hooks";
import { INITIAL_STATE, singleContactReducer } from "../../reducers/singleContactReducer";
import { useSelector } from "react-redux";
import { useAspDispatch } from "../../../../test/jest-redux-hooks";

export const TagsFilters = ({ activeFilter, setActiveFilter, tagList = [], addTag, removeTag }) => {
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(true);
  const [hoveredTagId, setHoveredTagId] = useState(null);
  const [showAddTagModal, setShowAddTagModal] = useState(false);
  const [showAllTags, setShowAllTags] = useState(false);
  const { currentBrand } = useAspSelector((state) => state.app);

  const [data, viewDispatch] = useReducer(singleContactReducer, INITIAL_STATE);
  const [currentTags, setCurrentTags] = useState(data?.tags);
  const {
      singleContactUploadDetails: { contact, address },
      singleContactDetails,
    } = useSelector((store) => store.crm);

   const selectedTags = useMemo(() => {
      return singleContactDetails["selected_tags"];
    }, [singleContactDetails?.selected_tags]);

  const dispatch = useAspDispatch();


  const visibleTags = showAllTags ? tagList : tagList.slice(0, 5);

  const handleDeleteTag = (e, tagId) => {
    e.stopPropagation(); // Prevent triggering the onClick of the parent div
    // In a real implementation, this would call an API to delete the tag
    console.log("Delete tag clicked", tagId);
  };

  const handleAddTag = () => {
    // In a real implementation, this would open a modal to add a new tag
    console.log("Add tag clicked");
  };

  const closeAction = async (id) => {
      const brandId = currentBrand?.brand_id;
  
      const updatedTags = singleContactDetails["selected_tags"].filter(
        (item) => item !== id
      );
  
      dispatch(
        updateSingleContactDetails({
          access_name: "selected_tags",
          value: updatedTags,
        })
      );
  
      setCurrentTags((prevTags) => {
        const newTags = prevTags.filter((item) => item.id !== id);
        return newTags;
      });
  
      if (brandId) {
        try {
          const response = await crmTagRemove(cp_id.id, id, brandId);
          if (response?.status === 200) {
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content: response?.data?.message,
                  status: "Success",
                  duration: 3000,
                },
              ])
            );
            crmSingleContactView(brandId, cp_id.id);
          } else {
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content: response?.response?.data?.error,
                  status: "Error",
                  duration: 3000,
                },
              ])
            );
          }
        } catch (error) {}
      }
    };

  const addAction = async (id) => {
      const brandId = currentBrand?.brand_id;
      const newTag = tagList.find((tag) => tag.id === id);

      console.log("Add tag clicked", id);



  
      // if (!singleContactDetails["selected_tags"].includes(id)) {
        // if (brandId) {
        //   try {
        //     const payLoad = { cp_id: cp_id.id };
        //     const response = await crmTagSingleAssign(cp_id?.id, id, brandId);
        //     if (response && response.status === 200) {
        //       const newTag = tagList.find((tag) => tag.id === id);
  
        //       setCurrentTags((prevTags) => [...prevTags, newTag]);
        //       dispatch(
        //         updateSingleContactDetails({
        //           access_name: "selected_tags",
        //           value: [...singleContactDetails.selected_tags, id],
        //         })
        //       );
  
        //       dispatch(
        //         updateToggleToast([
        //           ...toggleToast,
        //           {
        //             id: toggleToast?.length + 1,
        //             content: response?.data?.message,
        //             status: "Success",
        //             duration: 3000,
        //           },
        //         ])
        //       );
        //     } else {
        //       dispatch(
        //         updateToggleToast([
        //           ...toggleToast,
        //           {
        //             id: toggleToast?.length + 1,
        //             content: response?.response?.data?.error,
        //             status: "Error",
        //             duration: 3000,
        //           },
        //         ])
        //       );
        //     }
        //   } catch (error) {}
        // }
      // }
    };

  return (
    <div className="mb-2">
      <div className="flex justify-between items-center px-4 py-3">
        <div 
          className="flex items-center cursor-pointer"
          onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
        >
          <p className="font14px-600 text-gray-800">Tags</p>
          <span
            className={`transition-transform duration-300 ml-2 ${
              isFilterDropdownOpen ? "transform rotate-180" : ""
            }`}
          >
            <Chevron />
          </span>
        </div>
        <button 
          className="text-blue-600 text-sm font-medium flex items-center"
          onClick={handleAddTag}
        >
          <span className="mr-1">+</span> 
          <Tags
          tagList={tagList}
          addAction={addTag}
          // closeAction={closeAction}
          Button={
            <p className="">
              <span>Add Tag</span>
            </p>
          }
        />
        </button>
      </div>

      <div
        className={`transition-all duration-200 overflow-hidden ${
          isFilterDropdownOpen ? "max-h-150" : "max-h-0"
        }`}
      >
        {visibleTags.map((tag) => (
          <div 
            key={tag.id}
            className={`flex items-center justify-between mx-4 px-3 py-2 rounded-md cursor-pointer ${
              activeFilter.tag === tag.tag ? "sidebar-sub-header-active" : "sidebar-sub-header hover:bg-slate-100"
            }`}
            
            onMouseEnter={() => setHoveredTagId(tag.id)}
            onMouseLeave={() => setHoveredTagId(null)}
          >
            <div className="flex items-center gap-3"
            onClick={() => {setActiveFilter(tag)
              console.log("Tag clicked", tag);
            }}
            >
              <div className="text-gray-500">
                <CrmTagIcon />
              </div>
              <p className={`${activeFilter.tag === tag.tag ? "text-green-700 font14px-500" : "font14px-400 text-gray-700"}`}>
                {/* {tag.tag} */}
                {(tag.tag || tag.name)?.charAt(0).toUpperCase() + (tag.tag || tag.name)?.slice(1)}
              </p>
            </div>
            {hoveredTagId === tag.id && (
              <div 
                className="text-gray-400 hover:text-gray-600"
                onClick={(e) => removeTag(tag.id)}
              >
                <Close width="16" height="16" circle={false} stroke="#6B7280" strokeWidth="1.5" />
              </div>
            )}
          </div>
        ))}
        

        {tagList.length > 5 && (
          <div className="text-center mt-2">
            <button 
              className="text-blue-600 text-sm font-medium"
              onClick={() => setShowAllTags(!showAllTags)}
            >
              {showAllTags ? "Show less" : "Show more"}
            </button>
          </div>
        )}

      </div>
    </div>
  );
};
